import React from 'react';
import { withStyles } from '@material-ui/core';
import { ActionBarContext } from 'utils/ActionBarContextProvider';
import { useSnackBar } from 'components/common/SnackBars/SnackBar.hooks';
import FormView from 'components/FormView';
import styles from './MovementDetails.styles';
import MovementDetailFrom from './MovementDetails.form';
import { IMovementDetailsHandle, IMovementDetailsProps, setActionBarFn } from './MovementDetails.properties';
import { ActionBarIcons, changeConfirmationDialogDefaults } from './MovementDetails.constants';
import {
  useMEContextSelector
} from '../MovementEnquiry.context';

const setActionBarButtons = (setActionBarCallBack: setActionBarFn): void => { setActionBarCallBack(ActionBarIcons); };

const MovementDetails = (props: IMovementDetailsProps, ref: React.Ref<IMovementDetailsHandle>): JSX.Element => {
  const { classes, changeConfirmationDialog, resetForm, dirty, formValues, destroyForm } = props;
  const { setActionBar } = React.useContext(ActionBarContext);
  const { showSnackBar } = useSnackBar();
  const onCancelClicked = React.useRef(false);
  const movementSummary = useMEContextSelector<'MovementEnquiry'>((state) => state.SummaryPanelData) as any;

  const [internalDirty, _setInternalDirty] = React.useState<boolean>(false);
  const isDirty = internalDirty || dirty;

  const resetAndNavigateBack = (callBack: () => void) => {
    resetForm();
    destroyForm();
    callBack();
  };

  React.useImperativeHandle(
    ref,
    () => ({
      isChangesSavedOrDiscarded(): boolean {
        if (isDirty) showSnackBar({ variant: 'warning', message: 'Please save or discard changes.' });

        return !isDirty;
      },
      OrderDetailsCancel(navigateBack: () => void): void {
        onCancelClicked.current = true;
        if (!isDirty) return resetAndNavigateBack(navigateBack);

        changeConfirmationDialog({
          ...changeConfirmationDialogDefaults,
          onOk: () => {
            resetAndNavigateBack(navigateBack);
          },
          onCancel: () => {
            onCancelClicked.current = false;
          }
        });
      }
    }),
    [formValues, isDirty]
  );

  React.useEffect(
    () => { setActionBarButtons(setActionBar); },
    []
  );

  return (
    <div className={classes.formContainer}>
      <FormView
        isLoading={false}
        formName={'PurchaseOrdersOrderDetails'}
        schema={MovementDetailFrom}
        includeTabsHeight={true}
        initialValues={movementSummary?.inlineObject}
        valuesSchema={movementSummary?.schema}
        operationMode={'EDIT'}
        fieldExtensions={{}}
      />
    </div>
  );
};

export default withStyles(styles, { index: 1 })(React.memo(React.forwardRef(MovementDetails)));
